import { generateLoginOTP } from 'actions/LoginSignupActions/generateLoginOtpActions';
import { updateIdentity } from 'actions/LoginSignupActions/updateIdentityActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
export default function updateEmailMobile(state = {
    asyncStatus: INIT
}, action) {
    switch (action.type) {
        case updateIdentity.USER_UPDATE_IDENTITY_REQUEST:
        case generateLoginOTP.USER_GENERATE_OTP:
            return Object.assign({}, {
                asyncStatus: LOADING
            });
        case updateIdentity.USER_UPDATE_IDENTITY_SUCCESS:
        case generateLoginOTP.USER_GENERATE_OTP_SUCCESS:
            return Object.assign({}, action.data, {
                asyncStatus: SUCCESS
            });
        case updateIdentity.USER_UPDATE_IDENTITY_ERROR:
        case generateLoginOTP.USER_GENERATE_OTP_ERROR:
            const error = action['error'];
            return Object.assign({}, error['RESPONSE'], {
                asyncStatus: ERROR
            });
        default:
            return state;
    }
}
